import { render, staticRenderFns } from "./NewtonFirstLawViz.vue?vue&type=template&id=2d8d387f&scoped=true"
import script from "./NewtonFirstLawViz.vue?vue&type=script&lang=js"
export * from "./NewtonFirstLawViz.vue?vue&type=script&lang=js"
import style0 from "./NewtonFirstLawViz.vue?vue&type=style&index=0&id=2d8d387f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8d387f",
  null
  
)

export default component.exports